"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/components/Highlighter.js";
exports.default = Highlighter;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Highlighter(_ref) {
  var hit = _ref.hit,
      attributeName = _ref.attributeName,
      highlight = _ref.highlight,
      highlightProperty = _ref.highlightProperty;

  var parsedHighlightedValue = highlight({ hit: hit, attributeName: attributeName, highlightProperty: highlightProperty });
  var reactHighlighted = parsedHighlightedValue.map(function (v, i) {
    var key = "split-" + i + "-" + v.value;
    if (!v.isHighlighted) {
      return _react2.default.createElement(
        "span",
        { key: key, className: "ais-Highlight__nonHighlighted", __source: {
            fileName: _jsxFileName,
            lineNumber: 8
          }
        },
        v.value
      );
    }
    return _react2.default.createElement(
      "em",
      { key: key, className: "ais-Highlight__highlighted", __source: {
          fileName: _jsxFileName,
          lineNumber: 10
        }
      },
      v.value
    );
  });
  return _react2.default.createElement(
    "span",
    { className: "ais-Highlight", __source: {
        fileName: _jsxFileName,
        lineNumber: 12
      }
    },
    reactHighlighted
  );
}

Highlighter.propTypes = {
  hit: _react2.default.PropTypes.object.isRequired,
  attributeName: _react2.default.PropTypes.string.isRequired,
  highlight: _react2.default.PropTypes.func.isRequired,
  highlightProperty: _react2.default.PropTypes.string.isRequired
};
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Highlighter, "Highlighter", "src/components/Highlighter.js");
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/components/Highlighter.js
// module id = 510
// module chunks = 0